import { Component, EventEmitter, Input, Output } from '@angular/core';
import { SafeUrlPipe } from '../../../../../../pipes/safe-url.pipe';

@Component({
  selector: 'app-execution-of-traffic-organization-projects-map',
  standalone: true,
  imports: [
    SafeUrlPipe
  ],
  templateUrl: './execution-of-traffic-organization-projects-map.component.html'
})
export class ExecutionOfTrafficOrganizationProjectsMapComponent {
  @Input()
  public contentUrl: string = '';

  @Output()
  public close = new EventEmitter();
}
